import { createId } from 'shared/util';
import { createToolBox, tools } from 'uScope/js/extensions/annotations/annotations-ui/tools';
import Vue from 'vue';
import ToolbarButton from '../../../components/vue/toolbar-button';
import toolbarIcon from '../assets/AnnotPanel-24.png';
import AnnotationsPanel from './AnnotationsPanel';
import RegionToolbar from './RegionToolbar';
import { getVueI18n, translate } from 'shared/services/I18nService';

export function UiLoader (uScope) {
  const toolbox = createToolBox();
  tools.forEach(t => t.install(toolbox));

  this.regionToolbar = createRegionToolbar(toolbox);
  createDialog(toolbox);
  createUscopeToolbarButton(uScope);
}

function createRegionToolbar (toolbox) {
  const addOns = [];
  const panels = [];
  const {div, id} = makeDiv();
  document.body.appendChild(div);
  return {
    addButton ({button}) {
      addOns.push({
        button,
        key: addOns.length
      });
    },
    addPanel ({ui}) {
      panels.push({
        ui,
        key: panels.length
      });
    },
    extend: toolbox.extend, // This is more of a mutator, not an extender... Todo: give a name that reflects its purpose better.
    component: new Vue({
      el: `#${id}`,
      i18n: getVueI18n(),
      render (h) {
        return h(RegionToolbar, {props: {addOns: this.addOns, panels: this.panels, toolbox}});
      },
      data () {
        return { addOns, panels };
      },
      components: {RegionToolbar}
    })
  };
}

function createDialog (toolbox) {
  const {div, id} = makeDiv();
  document.body.appendChild(div);

  // eslint-disable-next-line no-new
  new Vue({
    el: `#${id}`,
    i18n: getVueI18n(),
    render: h => h(AnnotationsPanel, {props: {toolbox}}),
    components: {AnnotationsPanel}
  });
}

function createUscopeToolbarButton (uScope) {
  const {div, id} = makeDiv();
  uScope.topToolbar.addButton(div);
  // eslint-disable-next-line no-new
  new Vue({
    el: `#${id}`,
    i18n: getVueI18n(),
    render: h => h(ToolbarButton, {
      props: {
        onClick () {
          this.$dispatch('TOGGLE_DRAW_TOOLS');
        },
        title: translate('uScope.extensions.annotations.toobarIcon-title'),
        icon: toolbarIcon
      }
    }),
    components: {ToolbarButton}
  });
}

function makeDiv () {
  const id = createId();
  const div = document.createElement('div');
  div.setAttribute('id', id);
  return {div, id};
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/annotations-ui/UiLoader.js